import { Order } from "../types/Order.interface";

const statuses: {} = {
    accepted: 'Принят',
    confirmed: 'На сборке',
    notified_customer: 'Принят',
    canceled: 'Отменен',
    collected: 'Готов к выдаче',
    regionCollected: 'На упаковке',
    issued: 'Выдан',
    regionIssued: 'Передан в ТК',
    packed: 'Готов к выдаче',
    regionPacked: 'Готов к передачи в ТК',
};

export function getStatusDescription(order: Order, toLowerCase: boolean = true): string {
    let status = order.status;

    if (order.delivery.company && Object.keys(order.delivery.company).length) {
        if(status === 'collected') status = 'regionCollected';
        else if(status === 'packed') status = 'regionPacked';
    }

    // @ts-ignore
    return statuses[status] !== undefined ? (toLowerCase ? statuses[status].toLowerCase() : statuses[status]) : '';
};